<template>
  <div class="table__rows-container">
    <div
      v-for="item in data"
      :key="item.id"
      class="table__row"
      :class="rowClass"
    >
      <!-- 1 -->
      <div>
        <router-link class="link" :to="`/txs/${item.tx_hash}`">
          {{ ellipsis(item.tx_hash, 8) }}
        </router-link>
      </div>

      <!-- 2 -->
      <div>
        <span>{{ item.timeDiff }}</span>
      </div>

      <!-- 3 -->
      <div>
        <span v-if="item.amount">{{ item.amount }}</span>
        <span v-else>-</span>
      </div>

      <!-- 4 -->
      <div>
        <span>{{ item.type }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ellipsis } from "../../../js/format";

export default {
  props: ["data", "accountAddress", "rowClass"],
  methods: {
    ellipsis: ellipsis,
  },
};
</script>

<style lang="scss">
@mixin transferRow($width) {
  .from-address-arrow {
    a,
    span {
      min-width: $width;
    }
  }
}

.table__row--txs {
  @include transferRow(65%);

  &Home {
    @include transferRow(95px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/shared/TableSlotTxHome.vue